import { USERS_URL } from "../../constants";
import { apiSlice } from "./../apislice";

export const usersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/login`,
        method: "POST",
        body: data,
        withCredentials: true,
        credentials: "include",
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: `${USERS_URL}/logout`,
        method: "POST",
        withCredentials: true,
        credentials: "include",
      }),
    }),
    resetLink: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/sendResetPasswordLink`,
        method: "POST",
        body: data,
        withCredentials: true,
        credentials: "include",
      }),
    }),
    resetPassword: builder.mutation({
      query: ({ data, token }) => ({
        url: `${USERS_URL}/resetPassword?token=${token}`,
        method: "POST",
        body: data,
        withCredentials: true,
        credentials: "include",
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useResetLinkMutation,
  useResetPasswordMutation,
} = usersApiSlice;
